import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { ShopDataResponse } from '../interfaces/shop-response.interface';
import { environment } from '@env/environment';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { UpdateShop } from '@app/utils/interfaces/update-shop.interface';

@Injectable({
  providedIn: 'root',
})
export class ShopSettingsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  public getShop(id: string): Observable<ShopDataResponse> {
    return this.http.get<ShopDataResponse>(`${this.baseUrl}${ApiEndpoints.SHOPS}/${id}`);
  }

  public updateShop(data: UpdateShop): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}${ApiEndpoints.SHOPS}`, data).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
